// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* the slides */
.slick-slide {
    margin: 0 5px;
}

/* the parent */
.slick-list {
    margin: 0 2px;
    height: inherit !important;
}

.slick-slider {
    height: 24rem !important;
}

.alice-carousel__wrapper {
    height: auto !important
}

.__target {
    width: 100% !important;
}

.slick-next, .slick-prev {
    font-size: 0;
    line-height: 0;
    top: 50%;
    width: 40px;
    height: 40px;
    transform: translate(0,-50%);
    cursor: pointer;
    color: #fff;
    border: 1px solid #fff;
    z-index: 999;
    border-radius: 50%;
    outline: 0;
    background: #fff;
    box-shadow: 0px 0px 5px #00000033;
}

.slick-next:focus, .slick-next:hover, .slick-prev:focus, .slick-prev:hover {
    color: black;
    outline: 0;
    background: white;
}

.slick-prev:before{
    content: '\\27F5';
    font-size: small;
    color: black;
    text-shadow: 0em 0.04em 0em black;
}

.slick-next:before{
    content: '\\27F6';
    font-size: small;
    color: black;
    text-shadow: 0em 0.04em 0em black;
}

#descripcion .alice-carousel__wrapper {
    height: 50vh !important;
    text-align: -webkit-center ;
}

.slick-dots {
    display: none !important;
}

@media (max-width: 1024px) {
    .btn-carrusel-mons-izq {
        display: none !important;
    }

    .btn-carrusel-mons-drc {
        display: none !important;
    }
}

@media (max-width: 1310px) {
    .section-construvida-carousel {
        padding: 0px 0rem !important;
    }
}

@media (max-width: 1140px) {
    .section-grid-construvida {
        width: 90% !important;
        justify-content: center;
        place-items: center;
    }
}

@media (max-width: 1024px) {
    .section-grid-construvida {
        width: 95% !important;
        justify-content: center;
        place-items: center;
    }

    .img-deptos-md {
        height: 15rem !important;
    }

    .slick-slider {
        height: 17rem !important;
    }

    .col1-mon {
        width: 15% !important;
    }

    .col2-mon {
        width: 70% !important;
    }

    .col3-mon {
        width: 15% !important;
    }
}

@media (max-width: 1024px) {
    .img-deptos-md {
        height: 15rem !important;
    }

    .slick-slider {
        height: 14rem !important;
    }
}

@media (max-width: 991px) {
    .section-grid-construvida {
        width: 50% !important;
        justify-content: center;
        place-items: center;
    }
}

@media (max-width: 988px) {
    .section-grid-construvida {
        width: 50% !important;
        justify-content: center;
    }
}

@media (max-width: 880px) {
    .section-grid-construvida {
        width: 60% !important;
        justify-content: center;
        place-items: center;
    }
}

@media (max-width: 768px) {
    .section-grid-construvida {
        width: 70% !important;
        justify-content: center;
        place-items: center;
    }
    .slick-cloned{
        display: none !important;
    }

    .col1-mon {
        display: none !important;
    }

    .img-deptos-md {
        height: 15rem !important;
    }

    .slick-slide{
        margin: 0px;
    }

    .col2-mon {
        height: 50vh;
        padding: 4rem 0px!important;
    }

    .col3-mon {
        display: none !important;
    }

    .container-cols-mon {
        width: 100vh;
    }
}

@media (max-width: 767px) {
    .slick-slide{
        margin: 0px;
    }
}

@media (max-width: 550px) {
    .img-deptos-md {
        height: 14.5rem !important;
    }

    .section-grid-construvida {
        width: 95% !important;
        justify-content: center;
        place-items: center;
    }

    .container-cols-mon {
        justify-content: center;
        width: 50vh;
    }

    .col2-mon {
        padding: 4rem 0px !important;
        width: 55vh !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/styled.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,WAAW;IACX,YAAY;IAGZ,4BAA4B;IAC5B,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,4BAA4B;QAC5B,sBAAsB;IAC1B;AACJ","sourcesContent":["/* the slides */\n.slick-slide {\n    margin: 0 5px;\n}\n\n/* the parent */\n.slick-list {\n    margin: 0 2px;\n    height: inherit !important;\n}\n\n.slick-slider {\n    height: 24rem !important;\n}\n\n.alice-carousel__wrapper {\n    height: auto !important\n}\n\n.__target {\n    width: 100% !important;\n}\n\n.slick-next, .slick-prev {\n    font-size: 0;\n    line-height: 0;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    -webkit-transform: translate(0,-50%);\n    -ms-transform: translate(0,-50%);\n    transform: translate(0,-50%);\n    cursor: pointer;\n    color: #fff;\n    border: 1px solid #fff;\n    z-index: 999;\n    border-radius: 50%;\n    outline: 0;\n    background: #fff;\n    box-shadow: 0px 0px 5px #00000033;\n}\n\n.slick-next:focus, .slick-next:hover, .slick-prev:focus, .slick-prev:hover {\n    color: black;\n    outline: 0;\n    background: white;\n}\n\n.slick-prev:before{\n    content: '\\27F5';\n    font-size: small;\n    color: black;\n    text-shadow: 0em 0.04em 0em black;\n}\n\n.slick-next:before{\n    content: '\\27F6';\n    font-size: small;\n    color: black;\n    text-shadow: 0em 0.04em 0em black;\n}\n\n#descripcion .alice-carousel__wrapper {\n    height: 50vh !important;\n    text-align: -webkit-center ;\n}\n\n.slick-dots {\n    display: none !important;\n}\n\n@media (max-width: 1024px) {\n    .btn-carrusel-mons-izq {\n        display: none !important;\n    }\n\n    .btn-carrusel-mons-drc {\n        display: none !important;\n    }\n}\n\n@media (max-width: 1310px) {\n    .section-construvida-carousel {\n        padding: 0px 0rem !important;\n    }\n}\n\n@media (max-width: 1140px) {\n    .section-grid-construvida {\n        width: 90% !important;\n        justify-content: center;\n        place-items: center;\n    }\n}\n\n@media (max-width: 1024px) {\n    .section-grid-construvida {\n        width: 95% !important;\n        justify-content: center;\n        place-items: center;\n    }\n\n    .img-deptos-md {\n        height: 15rem !important;\n    }\n\n    .slick-slider {\n        height: 17rem !important;\n    }\n\n    .col1-mon {\n        width: 15% !important;\n    }\n\n    .col2-mon {\n        width: 70% !important;\n    }\n\n    .col3-mon {\n        width: 15% !important;\n    }\n}\n\n@media (max-width: 1024px) {\n    .img-deptos-md {\n        height: 15rem !important;\n    }\n\n    .slick-slider {\n        height: 14rem !important;\n    }\n}\n\n@media (max-width: 991px) {\n    .section-grid-construvida {\n        width: 50% !important;\n        justify-content: center;\n        place-items: center;\n    }\n}\n\n@media (max-width: 988px) {\n    .section-grid-construvida {\n        width: 50% !important;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 880px) {\n    .section-grid-construvida {\n        width: 60% !important;\n        justify-content: center;\n        place-items: center;\n    }\n}\n\n@media (max-width: 768px) {\n    .section-grid-construvida {\n        width: 70% !important;\n        justify-content: center;\n        place-items: center;\n    }\n    .slick-cloned{\n        display: none !important;\n    }\n\n    .col1-mon {\n        display: none !important;\n    }\n\n    .img-deptos-md {\n        height: 15rem !important;\n    }\n\n    .slick-slide{\n        margin: 0px;\n    }\n\n    .col2-mon {\n        height: 50vh;\n        padding: 4rem 0px!important;\n    }\n\n    .col3-mon {\n        display: none !important;\n    }\n\n    .container-cols-mon {\n        width: 100vh;\n    }\n}\n\n@media (max-width: 767px) {\n    .slick-slide{\n        margin: 0px;\n    }\n}\n\n@media (max-width: 550px) {\n    .img-deptos-md {\n        height: 14.5rem !important;\n    }\n\n    .section-grid-construvida {\n        width: 95% !important;\n        justify-content: center;\n        place-items: center;\n    }\n\n    .container-cols-mon {\n        justify-content: center;\n        width: 50vh;\n    }\n\n    .col2-mon {\n        padding: 4rem 0px !important;\n        width: 55vh !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
